var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`text-align: ${
    _vm.center ? 'center' : 'left'
  }; font-size: ${_vm.fontSize}; font-weight: ${_vm.fontWeight}`)},[_vm._v(" "+_vm._s(_vm.titleUperCase)+" "),(_vm.subtitle)?_c('div',[_c('span',{staticStyle:{"font-size":"16px"}},[_vm._v(_vm._s(_vm.subtitle))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }